/* eslint-disable react/prop-types */
import React from 'react';
import MediaQuery from 'react-responsive';

export const Desktop = ({ children }) => (
  <MediaQuery minWidth={992}>{children}</MediaQuery>
); // @screen-lg

export const Tablet = ({ children }) => (
  <MediaQuery minWidth={768} maxWidth={991}>
    {children}
  </MediaQuery>
); // @screen-md -> @screen-lg - 1

export const Mobile = ({ children }) => (
  <MediaQuery maxWidth={767}>{children}</MediaQuery>
); // @screen-md - 1

export const ExceptDesktop = ({ children }) => (
  <MediaQuery maxWidth={991}>{children}</MediaQuery>
); // @screen-lg - 1

export const ExceptMobile = ({ children }) => (
  <MediaQuery minWidth={768}>{children}</MediaQuery>
); // @screen-md

export default {};
